module.exports = __webpack_public_path__ + "img/technology-19.affe5fca.png";